module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "group group--sidebar group--query query pab2"
  }, [_c('h1', {
    staticClass: "h1 group__title mb0",
    style: ({
      'color': _vm.org.custom_color1 == null ? '' : _vm.org.custom_color1
    })
  }, [_vm._v("Request an Appointment Slot")]), _vm._v(" "), _c('p', {
    staticClass: "p group__description"
  }, [_vm._v("Complete the form to send your appointment request")]), _vm._v(" "), _c('ui-auth', {
    attrs: {
      "id": "appointmentQuery"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1a006f46"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/views/provider/Query.vue
// module id = 508
// module chunks = 0